import { render } from "./ProductDescriptionEntryGarantie.vue?vue&type=template&id=31fc9e85&scoped=true&ts=true"
import script from "./ProductDescriptionEntryGarantie.vue?vue&type=script&lang=ts"
export * from "./ProductDescriptionEntryGarantie.vue?vue&type=script&lang=ts"

import "./ProductDescriptionEntryGarantie.vue?vue&type=style&index=0&id=31fc9e85&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc9e85"]])

export default __exports__